/* eslint-disable react/no-array-index-key */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, styled, Tab, Tabs, Typography } from '@mui/material';

import { CompanyLeaderBoardUser } from './companyLeaderboardTypes';

const StyledLeaderboardScore = styled(Typography)(({ theme }) => ({
  width: 60,
  height: 30,
  display: 'block',
  textAlign: 'center',
  backgroundColor: theme.palette.grey[700],
  borderRadius: theme.spacing(1),
  color: theme.palette.grey[100],
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(4),
  padding: 0,
  fontSize: '13px',
  fontWeight: 600,
  minWidth: 'fit-content',
  color: '#919EAB',
  '&:hover': {
    opacity: 1,
  },
  '&.Mui-selected': {
    padding: 0,
    width: 'fit-content',
    color: theme.palette.grey[900],
  },
}));

interface LeaderboardHeaderProps {
  fullName: string;
  score: number;
  activeTeamTab: number;
  onChangeActiveTab: (_: React.SyntheticEvent, tab: number) => void;
  leaderBoard: CompanyLeaderBoardUser[];
}

export const CompanyLeaderboardHeader = ({
  fullName,
  score,
  activeTeamTab,
  onChangeActiveTab,
  leaderBoard,
}: LeaderboardHeaderProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'leaderboard' });
  const showTab = leaderBoard.length > 1;

  return (
    <Box sx={{ backgroundColor: '#1BFFAF', pt: 0, pl: 7.5, pr: 6, pb: 4, borderRadius: '12px 12px 0 0' }}>
      {showTab && (
        <Tabs
          value={activeTeamTab}
          onChange={onChangeActiveTab}
          sx={{
            '& .MuiTabs-scroller': { height: '40px' },
            '& .MuiTabs-flexContainer': { overflow: 'auto' },
            '& .MuiTabs-indicator': { backgroundColor: 'black' },
          }}
        >
          {leaderBoard.map((item, index: number) => (
            <StyledTab key={index} label={`${item.name}'s team`} disableRipple />
          ))}
        </Tabs>
      )}

      <Typography variant="h4" mb={5} color="grey.900" pt={showTab ? 0 : 4}>
        {t('companyTitle')}
      </Typography>
      <Box display="flex" alignItems="center" alignContent="space-between" justifyContent="space-between">
        <Typography variant="text1" mr={3} noWrap color="grey.900">
          {`🏆 ${fullName}`}
        </Typography>

        <Box display="flex" alignItems="center">
          <StyledLeaderboardScore mr={4} variant="text1">
            {Math.round(score * 10) / 10}
          </StyledLeaderboardScore>
        </Box>
      </Box>
    </Box>
  );
};
